import { create, windowScheduler } from "@yornaath/batshit";
import apiClient from "services/ApiClient";
import { createQueryString } from "helpers/queryString";
import { BATCH_WINDOW_MS, keyedObjectResolver } from "helpers/batcher";
import { NewHireJourney, NewHireJourneyId } from "models/v2/newHireJourney";

interface NewHireJourneyBatchKey {
  id: NewHireJourneyId;
}

const newHireJourneyBatcher = create({
  fetcher: async (keys: NewHireJourneyBatchKey[]): Promise<Record<NewHireJourneyId, NewHireJourney>> => {
    const ids = keys.map((key) => key.id);
    const queryString = createQueryString({ additionalQueries: { ids } });

    // Backend returns { data: { "123": {...}, "456": {...} } }
    const response = await apiClient.performRequest<{ data: Record<NewHireJourneyId, NewHireJourney> }>(
      `/api/new-hire-journeys/batch?${queryString}`,
    );

    return response.payload.data;
  },
  resolver: keyedObjectResolver("id"),
  scheduler: windowScheduler(BATCH_WINDOW_MS),
});

export default newHireJourneyBatcher;
